import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { TcsmStates } from '../../root/tcsm-model';
import { MyCpgMidYearEnrollment } from '../../pages/arc/features/new-hire-enrollment/member/models/member-coverage-model';
import { getOpenEnrollmentWindow } from '../ducks/mlps-api';
import { setMyCpgMidYearOpenEnrollment } from '../../pages/arc/features/new-hire-enrollment/slice/new-hire-enrollment-slices';


export function useMyCpgMidYearOpenEnrollments() {
	const enrollments = useSelector<TcsmStates, MyCpgMidYearEnrollment[]>(state => state.newHireEnrollmentState?.myCpgOpenEnrollment);
	const dispatch = useDispatch();
	const guid = useSelector<TcsmStates, string>(state => state?.authenticatedState?.clientGuid);

	useEffect(() => {

		dispatch(getOpenEnrollmentWindow(guid, (response) => {
			dispatch(setMyCpgMidYearOpenEnrollment(response?.data));
		}));

	}, [guid]);

	return enrollments;
}